
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import { SidebarProvider } from '@/components/ui/sidebar';
import AdminSidebar from './AdminSidebar';
import AdminBottomNav from '@/components/admin/AdminBottomNav';
import { useAuth } from '@/contexts/AuthContext';
import OptimizedLoading from '@/components/ui/OptimizedLoading';

const Layout = () => {
  const location = useLocation();
  const { isAdmin, isLoading } = useAuth();
  const isAdminRoute = location.pathname.includes('/admin');
  const [pageReady, setPageReady] = useState(true);
  
  // Log navigation for debugging
  useEffect(() => {
    console.log('Navigation to:', location.pathname);
  }, [location.pathname]);

  if (isLoading) {
    return <OptimizedLoading size="small" message="Checking authentication..." />;
  }

  return (
    <SidebarProvider>
      <div className="flex min-h-screen bg-background">
        {isAdminRoute && isAdmin && <AdminSidebar />}
        <div className="flex flex-col flex-1">
          <Navbar />
          <main className="flex-1 p-4 overflow-auto">
            <Outlet />
          </main>
          {isAdmin && <AdminBottomNav />}
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Layout;
